const IMAGES = {
  //HOME
  banner1: require("../img/home/b1.png"),
  banner2: require("../img/home/b2.png"),
  banner3: require("../img/home/b3.png"),
  banner4: require("../img/home/b4.png"),
  ycoin: require("../img/ecoin.png"),
  coin: require("../img/coin.png"),
  wallet: require("../img/wallet.png"),
  logo: require("../img/logo.png"),
  support: require("../img/support.png"),
  upis: require("../img/upis.png"),
  // socials
  facebook: require("../img/socials/facebook.png"),
  instagram: require("../img/socials/instagram.png"),
  whatsapp: require("../img/socials/logo.png"),
  telegram: require("../img/socials/telegram.png"),
  gmail: require("../img/socials/gmail.png"),
  wa: require("../img/socials/wa.png"),
  // payment
  upi: require("./upi.png"),
  paytm: require("./paytm.png"),
  gpay: require("./gpay.png"),
  phonepe: require("./phonepe.png"),
};

export default IMAGES;
